import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { apiRequest } from "../api/client";

const SUBTITLE =
  "Contrary to popular belief, Lorem Ipsum is not simply random text";

function TermsAndConditions({ onOpenAuth, onOpenMenu }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    async function fetchTerms() {
      setLoading(true);
      setError("");
      try {
        const res = await apiRequest("api/terms_and_conditions", {
          method: "GET",
        });
        if (cancelled) return;
        if (res.ok) {
          setData(res.data);
        } else {
          setError(
            res.data?.message || "Failed to load terms and conditions."
          );
        }
      } catch (err) {
        if (!cancelled) setError("Failed to load terms and conditions.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchTerms();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 md:px-6">
        <div className="px-6 py-8 md:px-10 md:py-10">
          {loading && (
            <div className="flex justify-center py-12">
              <span className="text-sm text-slate-500">Loading…</span>
            </div>
          )}

          {error && (
            <div className="py-8 text-center">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          {!loading && !error && data && (
            <>
              <h1 className="text-center text-2xl font-bold text-slate-900 md:text-3xl">
                {data.title || "Terms & Conditions"}
              </h1>
              <p className="mt-2 text-center text-sm text-slate-500">
                {SUBTITLE}
              </p>
              <div
                className="terms-content mt-8 space-y-6 text-left text-sm text-slate-700"
                dangerouslySetInnerHTML={{
                  __html: data.content || "",
                }}
              />
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default TermsAndConditions;
